/**
 * Utility to map frontend display names to backend API values for asset types and hierarchy levels.
 * Handles discrepancies like "Solar Module" (Frontend) vs "Module" (Backend).
 */

export const mapToBackendAssetType = (frontendAssetType: string): string => {
  if (!frontendAssetType) return 'Other';

  switch (frontendAssetType) {
    case 'Solar Module':
      return 'Module';
    case 'Grid Connection':
      return 'Substation'; // Best guess mapping for Grid Connection if needed, or leave as is if backend handles it
    case 'Junction Box':
      return 'Other'; // Map unknown types to Other
    case 'Combiner Box':
      return 'Other'; // Map unknown types to Other
    default:
      // Valid backend types: 'Inverter', 'String', 'Module', 'ACDB', 'Transformer', 'Substation', 'AC Cable', 'DC Cable', 'HT Cable', 'Other'
      // If the type matches one of these, return it as is.
      // If it's a known frontend type that needs mapping, it should be handled above.
      return frontendAssetType;
  }
};

/**
 * Validates if the mapped type is accepted by the backend.
 * Useful for debugging or pre-validation.
 */
export const isValidBackendType = (type: string): boolean => {
  const validTypes = [
    'Inverter', 
    'String', 
    'Module', 
    'ACDB', 
    'Transformer', 
    'Substation', 
    'AC Cable', 
    'DC Cable', 
    'HT Cable', 
    'Other'
  ];
  return validTypes.includes(type);
};

